import React, { useState, useEffect, useRef} from "react";
import "./Authentication.css";
import { FaEye, FaSlack } from 'react-icons/fa';
import { FaEyeSlash } from 'react-icons/fa';
import { supabase } from "./supabase-client";
 

const Auth = () => {
    
    const [passwordHidden, setPasswordHidden] = useState(true);
    const [isSingUp, setSignUp] = useState(false);

    const [email,setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const[verifyEmail, setVerifyEmail] = useState(false);


    const handleSubmit = async (e) => {

        e.preventDefault();

        if(isSingUp){
            const {error,data} = await supabase.auth.signUp({email,password});

            if(error){
                console.error("Error Signing Up:", error.message);
                setErrorMessage(error.message);
                return;
            }
            else if(data?.user && !data.session){
                
                setErrorMessage("Email already in use");
                console.error("Error Signing Up:", "Email already in use");
            }

            setVerifyEmail(true);


        }else{

            const {error} = await supabase.auth.signInWithPassword({email,password});

            if(error){
                console.error("Error Logining In:", error.message);
                setErrorMessage(error.message);
                return;
            }


        }

    }

    const buttonRef = useRef(null);

    const handleKeyPress = (e) => {
        if(e.key == "Enter"){
            buttonRef.current.click();
        } 

    }
    
    return (

        <div className="page-1">

            {verifyEmail ? 

                <div className="main-1">

                    <h3 className="main-text">A verification mail has been sent to: </h3>
                    <h3 className="email-text">{email}</h3>
                    <h3 className="main-text">Please confirm it to proceed</h3>

                </div> 
            
                :
            
            <div className="main-1">
            
                <h1 className="main-text">{isSingUp ? "Sign Up" : "Login"}</h1>

                <div className="mail">
                    <h3>E-mail</h3>
                    <input value={email} type="email" onChange={e => setEmail(e.target.value)} placeHolder="something@gmail.com" ></input>
                </div>
                <div className="password">
                    <h3>Password</h3>
                    <div className="password-input">
                        <input value={password} onChange={e => setPassword(e.target.value)} placeHolder="Password" onKeyDown={handleKeyPress} type={passwordHidden ? "password" : ""}></input>
                        {passwordHidden ? <FaEyeSlash className="password-icon" onClick={() => {setPasswordHidden(false)}}></FaEyeSlash> : <FaEye className="password-icon" onClick={() => {setPasswordHidden(true)}}></FaEye>}
                    </div>
                    
                </div>

                <div className="error-message">
                    <p>{errorMessage}</p>
                </div>

                <div className="login">
                    <button ref={buttonRef} onClick={handleSubmit}>{isSingUp ? "Sign Up":"Login"}</button>                
                </div>
                <div className="switch">
                    <h3>{isSingUp ? "Already have an Account? " : "Don't have an Account?"}</h3> <h3 className="switch-button" onClick={() => {setSignUp(!isSingUp); setEmail(""); setPassword(""); setErrorMessage("")}}>{isSingUp ? " Login." : " Sign Up."}</h3>
                </div>

            </div>}
            


        </div>
        
    );
};
export default Auth;